import { inject, signal, Signal } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';

import { GqlService, ListInvestigatorForecastPeriodDataInput } from '@shared/services/gql.service';
import { OverlayService } from '@shared/services/overlay.service';
import { MainQuery } from '@shared/store/main/main.query';
import { gqlToPromise } from '@shared/utils/gql-to-promise';
import { Utils } from '@shared/utils/utils';

const investigatorKeys = {
  index: ['investigator-forecast'] as const,
  periodData: (trialKey: string, dataInput: ListInvestigatorForecastPeriodDataInput) =>
    [...investigatorKeys.index, 'period-data', { dataInput, trialKey }] as const,
};

export const injectInvestigatorForecastPeriodData = ({
  enabled = signal(true),
  input,
}: {
  enabled?: Signal<boolean>;
  input: Signal<ListInvestigatorForecastPeriodDataInput>;
}) => {
  const gqlService = inject(GqlService);
  const mainQuery = inject(MainQuery);
  const overlayService = inject(OverlayService);

  return injectQuery(() => ({
    enabled: !!input().start_date && !!input().end_date && enabled(),
    onError: (error: string[]) => {
      overlayService.error(error);
    },
    queryFn: async () => {
      const resp = await gqlToPromise(() =>
        gqlService.listInvestigatorForecastPeriodData$(input())
      );

      return resp?.sort((a, b) => Utils.dateSort(a.period, b.period)) || [];
    },
    queryKey: investigatorKeys.periodData(mainQuery.trialKey(), input()),
  }));
};
